import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Stack, Slider, Typography } from "@mui/material";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  sliderWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    margin: theme.spacing(2, 0)
  },
  slider: {
    margin: theme.spacing(0, 2)
  }
}));

const FlowBuilderIntervalModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [timerSec, setTimerSec] = useState(0);
  const [activeModal, setActiveModal] = useState(false);

  useEffect(() => {
    if (open === 'edit') {
      setTimerSec(data.data.sec);
      setActiveModal(true);
    } else if (open === 'create') {
      setTimerSec(0);
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSliderChange = (event, newValue) => {
    setTimerSec(newValue);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value > 120) {
      toast.error('Máximo de tempo atingido 120 segundos');
      setTimerSec(120);
    } else {
      setTimerSec(value);
    }
  };

  const handleSaveContact = async () => {
    if (!timerSec || parseInt(timerSec) <= 0) {
      return toast.error('Adicione o valor de intervalo');
    }
    if (parseInt(timerSec) > 120) {
      return toast.error('Máximo de tempo atingido 120 segundos');
    }
    if (open === 'edit') {
      onUpdate({
        ...data,
        data: { sec: timerSec }
      });
    } else if (open === 'create') {
      onSave({
        sec: timerSec
      });
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">
          {open === 'create' ? `Adicionar um intervalo ao fluxo` : `Editar intervalo`}
        </DialogTitle>
        <DialogContent dividers>
          <Stack direction={'column'} alignItems={'center'} gap={3}>
            <div className={classes.sliderWrapper}>
              <Typography variant="body2" color="textSecondary">0s</Typography>
              <Slider
                value={timerSec}
                onChange={handleSliderChange}
                step={1}
                marks
                min={0}
                max={120}
                valueLabelDisplay="auto"
                className={classes.slider}
                aria-labelledby="input-slider"
              />
              <Typography variant="body2" color="textSecondary">120s</Typography>
            </div>
            <TextField
              label={'Tempo em segundos'}
              name="timer"
              type="number"
              value={timerSec}
              onChange={handleInputChange}
              variant="outlined"
              InputProps={{ inputProps: { min: 0, max: 120 } }}
              margin="dense"
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            variant="outlined"
          >
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            className={classes.btnWrapper}
            onClick={handleSaveContact}
          >
            {open === 'create' ? `Adicionar` : 'Editar'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderIntervalModal;